import React, { useState } from "react";
import { Box } from "@mui/material";
import Drawer from "./Drawer";
import { AppBar } from "./AppBar.jsx";
import { styled } from "@mui/material/styles";
// import ReturnToAppointmentWidget from "./client/ReturnToAppointmentWidget";
import { SnackbarMessages } from "./Snackbar.jsx";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  marginTop: theme.spacing(3),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export default function Layout({ children }) {
  const [open, setOpen] = useState(true);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar open={open} />
      <Drawer
        open={open}
        handleDrawerClose={handleDrawerClose}
        handleDrawerOpen={handleDrawerOpen}
      />
      <Box component="main" sx={{ flexGrow: 1, px: 3 }}>
        <DrawerHeader />
        {children}
        {/* <ReturnToAppointmentWidget /> */}
      </Box>
      <SnackbarMessages />
    </Box>
  );
}
